import { CustomButton } from '../../../features/customButton'
import { PROMO_CODE_TYPES } from '../../../../constants/tasksTypes'
import { useTranslation } from '../../../../translations'

export default function TaskItemButtonLink2({ quest }) {
  const { type, button_link_2 } = quest

  const { t } = useTranslation()

  const isVisible = PROMO_CODE_TYPES.includes(type) && button_link_2

  return (
    isVisible && (
      <CustomButton
        className={'button_task task__item-button custom-button_challenge'}
        tag={'a'}
        text={t('task.buttons.firstOrder')}
        href={button_link_2}
        target={'_blank'}
      />
    )
  )
}
